angular.module('shared').directive('formattedDateBinding', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(viewValue) {
        if (moment(viewValue).isValid()) {
          return moment(viewValue).format(attrs.formattedDateBinding);
        }
      });
      return ngModel.$formatters.push(function(viewValue) {
        if (moment(viewValue, 'DD-MM-YYYY', true).isValid()) {
          return moment(viewValue, 'DD-MM-YYYY').format(attrs.datepickerPopup.toUpperCase());
        }
        if (moment(viewValue, 'YYYY-MM-DD', true).isValid()) {
          return moment(viewValue, 'YYYY-MM-DD').format(attrs.datepickerPopup.toUpperCase());
        }
      });
    }
  };
});
